import { Collection } from 'modules/core/lib/mobx-rest'

import TemplateCustomField from 'modules/documents/store/models/CustomFieldVariable'

class customFieldVariables extends Collection<TemplateCustomField> {
  get cacheKey(): string {
    return 'customFieldVariables'
  }

  model() {
    return TemplateCustomField
  }

  byVariable(variable: string): TemplateCustomField | null | undefined {
    return this.find({
      variable,
    })
  }

  // Model not coming from database so need to define primary key
  get primaryKey(): string {
    return 'variable'
  }
}

const singleton: customFieldVariables = new customFieldVariables()

export default singleton
